var SourceChangesActions;
(function (SourceChangesActions) {
    SourceChangesActions["ASSIGN"] = "assign";
    SourceChangesActions["UNASSIGN"] = "unassign";
})(SourceChangesActions || (SourceChangesActions = {}));
export default SourceChangesActions;
